// Página de entrada da venda pela loja (templates/page.nova-venda-revenda.liquid).
// O portal abre /pages/nova-venda-revenda#fg_cliente=<id da conta da loja>.
//
// Ao carregar, o fragmento sai do endereço antes de qualquer pedido. Um id
// válido vira o registro desta aba no armazenamento da sessão, conferido na
// leitura de volta; um fragmento inválido não troca o registro que já existe.
// O registro nunca vem da sessão da loja nem de outra aba.
//
// No DOMContentLoaded a página compara o registro com o cliente que a loja
// renderizou: sem sessão, uma única viagem automática ao login; outra conta,
// nenhuma venda; a mesma conta, um GET ao contexto da revenda antes de mostrar
// os inícios de venda. Se o armazenamento falhar, nada segue.
//
// Os textos do servidor entram só como texto. Não lê nem grava nada além da
// aba, e não faz outro pedido além do contexto.
(function (raiz) {
  'use strict';

  var CHAVE = 'fg-revenda.venda';
  var ENTRADA = '/pages/nova-venda-revenda';
  // O return_to só aceita caminho relativo:
  // shopify.dev/docs/storefronts/themes/sign-in
  var LOGIN = '/customer_authentication/login?return_to=%2Fpages%2Fnova-venda-revenda';
  var PORTAL = 'https://portal.fale.global/loja';
  var CONTEXTO = '/apps/revenda/contexto';

  // Id de cliente canônico, comparado como texto (20 dígitos passam do inteiro exato).
  var CONTA = /^[1-9]\d{0,19}$/;
  var FRAGMENTO = /^#fg_cliente=([1-9]\d{0,19})$/;
  // Caminho simples da própria loja, como o servidor valida o path_prefix.
  var CAMINHO = /^(\/[A-Za-z0-9._~-]+)+$/;
  var TEXTOS = ['faixa', 'credito', 'vender'];
  var VISTAS = ['preparando', 'entrar-auto', 'entrar', 'pronto', 'desconectada', 'falhou', 'conta-diferente', 'sem-portal', 'sem-armazenamento'];
  // A frase principal de cada vista, repetida na região viva.
  var AVISOS = {
    'entrar-auto': 'Abrindo o login da loja\u2026',
    entrar: 'Entre na loja com a conta conectada ao portal para continuar.',
    desconectada: 'Esta conta da loja n\u00e3o est\u00e1 mais conectada ao portal. Volte ao portal para conectar de novo.',
    falhou: 'N\u00e3o foi poss\u00edvel continuar agora.',
    'conta-diferente': 'Essa n\u00e3o \u00e9 a conta da loja conectada ao seu portal. Abra sua conta da loja, saia dela e entre com a conta conectada.',
    'sem-portal': 'Para vender pela loja, toque em Nova venda no portal.',
    'sem-armazenamento': 'Este navegador n\u00e3o permite preparar a venda pela loja. Toque em Nova venda no portal usando outro navegador.'
  };

  function texto(v) {
    return typeof v === 'string' && v !== '' ? v : null;
  }

  // Sem segmento . ou ..
  function caminhoDaLoja(v) {
    return typeof v === 'string' && CAMINHO.test(v) && !/\/\.\.?(?=\/|$)/.test(v);
  }

  // ── núcleo, sem DOM ──────────────────────────────────────────
  function lerFragmento(hash) {
    if (typeof hash !== 'string') return null;
    var m = FRAGMENTO.exec(hash);
    return m ? m[1] : null;
  }

  function lerRegistro(bruto) {
    if (typeof bruto !== 'string') return null;
    var r;
    try { r = JSON.parse(bruto); } catch (e) { return null; }
    if (!r || typeof r !== 'object' || Array.isArray(r)) return null;
    if (typeof r.cliente !== 'string' || !CONTA.test(r.cliente)) return null;
    if (r.tentativaEm !== null && typeof r.tentativaEm !== 'number') return null;
    return { cliente: r.cliente, tentativaEm: r.tentativaEm };
  }

  function decidir(estado) {
    if (!estado || estado.armazenamento !== true) return 'sem-armazenamento';
    var r = estado.registro;
    if (!r || typeof r.cliente !== 'string' || !CONTA.test(r.cliente)) return 'sem-portal';
    var sessao = typeof estado.sessao === 'string' && estado.sessao !== '' ? estado.sessao : null;
    if (sessao === null) return r.tentativaEm === null ? 'entrar-auto' : 'entrar';
    return sessao === r.cliente ? 'verificar' : 'conta-diferente';
  }

  // Iguais aos do asset da revenda: só um { revenda } completo, com o painel
  // num caminho da própria loja e o carrinho, quando vem, também.
  function lerResposta(status, corpo) {
    if (status !== 200 || typeof corpo !== 'string') return null;
    var dados;
    try { dados = JSON.parse(corpo); } catch (e) { return null; }
    var r = dados && typeof dados === 'object' ? dados.revenda : null;
    if (!r || typeof r !== 'object') return null;
    for (var i = 0; i < TEXTOS.length; i += 1) if (!texto(r[TEXTOS[i]])) return null;
    if (!caminhoDaLoja(r.vender)) return null;
    var carrinho = null;
    if (r.carrinho !== undefined && r.carrinho !== null) {
      if (!caminhoDaLoja(r.carrinho)) return null;
      carrinho = r.carrinho;
    }
    return { faixa: r.faixa, credito: r.credito, creditoNegativo: r.creditoNegativo === true, vender: r.vender, carrinho: carrinho };
  }

  function classificar(status, corpo) {
    if (lerResposta(status, corpo)) return 'revenda';
    if (status !== 200 || typeof corpo !== 'string') return 'falhou';
    var dados;
    try { dados = JSON.parse(corpo); } catch (e) { return 'falhou'; }
    if (!dados || typeof dados !== 'object' || Array.isArray(dados)) return 'falhou';
    var chaves = Object.keys(dados);
    return chaves.length === 1 && chaves[0] === 'revenda' && dados.revenda === null ? 'varejo' : 'falhou';
  }

  // Grava e confere a leitura de volta; qualquer diferença conta como falha.
  function gravar(s, registro) {
    s.setItem(CHAVE, JSON.stringify(registro));
    var lido = lerRegistro(s.getItem(CHAVE));
    if (!lido || lido.cliente !== registro.cliente || lido.tentativaEm !== registro.tentativaEm) throw new Error('registro');
    return lido;
  }

  // ── a página ─────────────────────────────────────────────────
  function iniciar(w) {
    var d = w.document;
    var loc = w.location;
    var hash = loc && typeof loc.hash === 'string' ? loc.hash : '';
    var fragmento = lerFragmento(hash);
    // Sem replaceState o fragmento fica no endereço, mas a página segue: a
    // viagem ao login e os links são fixos e nunca o levam adiante.
    if (hash) {
      try { w.history.replaceState(null, '', loc.pathname); } catch (e) { /* segue */ }
    }

    var s = null;
    var armazenamento = true;
    var registro = null;
    try {
      s = w.sessionStorage;
      registro = fragmento ? gravar(s, { cliente: fragmento, tentativaEm: null }) : lerRegistro(s.getItem(CHAVE));
    } catch (e) {
      armazenamento = false;
      registro = null;
    }

    function mostrar(vista, aviso) {
      for (var i = 0; i < VISTAS.length; i += 1) {
        var el = d.getElementById('fgnv-' + VISTAS[i]);
        if (el) el.hidden = VISTAS[i] !== vista;
      }
      var a = d.getElementById('fgnv-aviso');
      if (a) a.textContent = aviso || AVISOS[vista] || '';
    }

    function concluir(status, corpo) {
      var tipo = classificar(status, corpo);
      if (tipo !== 'revenda') { mostrar(tipo === 'varejo' ? 'desconectada' : 'falhou'); return; }
      var ctx = lerResposta(status, corpo);
      var faixa = d.getElementById('fgnv-faixa');
      var credito = d.getElementById('fgnv-credito');
      if (!faixa || !credito) { mostrar('falhou'); return; }
      faixa.textContent = ctx.faixa;
      credito.textContent = ctx.credito;
      mostrar('pronto', ctx.faixa);
    }

    function verificar() {
      var p;
      try {
        p = Promise.resolve(w.fetch(CONTEXTO, { method: 'GET', credentials: 'same-origin', headers: { Accept: 'application/json' } }));
      } catch (e) {
        p = Promise.reject(e);
      }
      p.then(function (r) { return r.text().then(function (corpo) { return [r.status, corpo]; }); })
        .then(function (x) { concluir(x[0], x[1]); }, function () { concluir(0, null); })
        .then(null, function () { return null; });
    }

    var feito = false;
    function aoCarregar() {
      if (feito) return;
      feito = true;
      var main = d.getElementById('fgnv');
      if (!main) return;
      var recarregar = d.getElementById('fgnv-recarregar');
      if (recarregar) recarregar.addEventListener('click', function () { loc.reload(); });

      var vista = decidir({ armazenamento: armazenamento, registro: registro, sessao: main.getAttribute('data-sessao') });
      if (vista === 'entrar-auto') {
        // Marca a tentativa antes de sair: na volta sem login não há outra viagem.
        try {
          gravar(s, { cliente: registro.cliente, tentativaEm: Date.now() });
        } catch (e) {
          mostrar('sem-armazenamento');
          return;
        }
        mostrar('entrar-auto');
        loc.replace(LOGIN);
        return;
      }
      if (vista === 'verificar') {
        if (registro.tentativaEm !== null) {
          try {
            gravar(s, { cliente: registro.cliente, tentativaEm: null });
          } catch (e) {
            mostrar('sem-armazenamento');
            return;
          }
        }
        verificar();
        return;
      }
      mostrar(vista);
    }

    if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', aoCarregar);
    else aoCarregar();
  }

  var nucleo = {
    CHAVE: CHAVE,
    ENTRADA: ENTRADA,
    LOGIN: LOGIN,
    PORTAL: PORTAL,
    CONTEXTO: CONTEXTO,
    lerFragmento: lerFragmento,
    lerRegistro: lerRegistro,
    decidir: decidir,
    classificar: classificar,
    lerResposta: lerResposta,
    iniciar: iniciar
  };

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = nucleo;
  } else if (raiz && raiz.document) {
    raiz.fgNovaVenda = nucleo;
    iniciar(raiz);
  }
})(typeof window !== 'undefined' ? window : null);
